module.exports = __webpack_public_path__ + "static/problem_bg.65f36815.png";